import React, { useEffect, useRef, useState } from 'react';
import { Translation } from 'react-i18next';
import {
  Affix, Button, Card, Checkbox, Col, Descriptions, List, Modal, Row, Table, Tabs, Typography,
} from 'antd';
import { DotChartOutlined, PlusOutlined, UserAddOutlined } from '@ant-design/icons';
import { FaBitcoin } from 'react-icons/fa';
import { GrGroup } from 'react-icons/gr';
import Footer from './common/FooterComponent';

const { Paragraph } = Typography;
const { TabPane } = Tabs;

function ReferralWithLoginComponent(props) {
  const [visible, setVisible] = useState(false);
  const [rateSelected, setRateSelected] = useState(0);
  const [baseCommissionRate, setBaseCommissionRate] = useState(20);
  const [editableStr, setEditableStr] = useState('Lưu ý');
  const [defaultCode, setDefaultCode] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [size, setSize] = useState('');
  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  let myRef = useRef(null);
  myRef = [];

  const defaultLink = 'https://www.binance.com/vn/register?ref=65900104';

  const dataSource1 = [
    {
      key: '1',
      id: '65900104',
      rate: `${baseCommissionRate - rateSelected}%/${rateSelected}%`,
      note: '-',
      friends: '0',
    },
  ];
  const dataSource2 = [];
  const dataSource3 = [];

  const columnsOfTable1 = [
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>ID Giới thiệu</span>,
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Bạn nhận được / Bạn bè nhận được</span>,
      dataIndex: 'rate',
      key: 'rate',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Lưu ý</span>,
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Bạn bè</span>,
      dataIndex: 'friends',
      key: 'friends',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Hành động</span>,
      key: 'actions',
      render: () => (
        <div size="middle">
          <a style={{ color: 'rgb(240, 185, 10)', fontSize: '14px' }}>Sao chép liên kết</a>
          <a style={{ marginLeft: '20px', color: 'rgb(240, 185, 10)', fontSize: '14px' }}>Sửa</a>
          <a style={{ marginLeft: '20px', color: 'rgb(240, 185, 10)', fontSize: '14px' }}>Mới</a>
        </div>
      ),
    },
  ];
  const columnsOfTable2 = [
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Ngày tháng</span>,
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Email của bạn bè</span>,
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Hoa hồng đã nhận được</span>,
      dataIndex: 'commissionreceived',
      key: 'commissionreceived',
    },
  ];
  const columnsOfTable3 = [
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Số lượng hoàn trả</span>,
      dataIndex: 'amountrefunded',
      key: 'amountrefunded',
    },
    {
      title: <span style={{ fontSize: '13px', fontWeight: 'lighter' }}>Ngày tháng</span>,
      dataIndex: 'date',
      key: 'date',
    },
  ];

  useEffect(() => {
    if (width < 576) {
      setSize('xs');
    } else if (width >= 576 && width < 768) {
      setSize('sm');
    } else if (width >= 768 && width < 992) {
      setSize('md');
    } else if (width >= 992 && width < 1200) {
      setSize('lg');
    } else if (width >= 1200 && width < 1600) {
      setSize('xl');
    } else setSize('xxl');
  }, [width]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const onCreateLink = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onSetDefaultCode = (e) => {
    setDefaultCode(e.target.checked);
  };

  const onSetReceive = (value) => {
    switch (value) {
      case value:

        break;

      default:
        break;
    }
  };

  const executeScroll = (i) => {
    myRef[i].scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div style={{ width }} className={`${size}-affiliate affiliate`}>
            <div className="affiliate-header">
              <Row gutter={72} className={`${size}-referral-header referral-header`}>
                <Col
                  xs={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className={`referral-header-covertext ${size}-referral-header-covertext`}
                >
                  <div className={`${size}-referral-header-covertext-text1`}>
                    {t('referral.header.right.text_1')}
                  </div>
                  <div className={`${size}-referral-header-covertext-text2`}>
                    {t('referral.header.right.text_2')}
                  </div>
                  <div className="referral-header-covertext-button">
                    <Button className={`mr-medium ${size}-referral-header-covertext-button-1`}>
                      {t('referral.header.right.button_1')}
                    </Button>
                    <Button className={`${size}-referral-header-covertext-button-2`}>
                      {t('referral.header.right.button_2')}
                    </Button>
                  </div>
                </Col>
                <Col xs={24} lg={12} xl={12} xxl={12}>

                  <div className="cover-referral">
                    <div className="d-flex align-items space-between">
                      <div className="cover-referral-text">
                        {t('referral.header.left.text_1')}
                      </div>
                      <Button
                        size="large"
                        type="link"
                        icon={<PlusOutlined />}
                        className="cover-referral-button"
                        onClick={onCreateLink}
                      >
                        {t('referral.header.left.button_1')}
                      </Button>
                    </div>
                    <Paragraph className="red" copyable>64389609</Paragraph>
                    <div>
                      <span className="cover-referral-text">{t('referral.header.left.text_2')}</span>
                      <Paragraph copyable>http://localhost:3000/referral</Paragraph>
                    </div>
                    <Paragraph
                      editable={{ onChange: setEditableStr }}
                      className="cover-referral-text"
                    >
                      {editableStr}
                    </Paragraph>
                    <Row gutter={4}>
                      <Col span={12}>
                        <Card
                          size="small"
                          title={(
                            <div
                              className="cover-referral-card-head"
                            >
                              {t('referral.header.left.card_1')}
                            </div>
)}
                        >
                          <div className="cover-referral-card-body"> 20%</div>
                        </Card>
                      </Col>
                      <Col span={12}>
                        <Card
                          size="small"
                          title={(
                            <div
                              className="cover-referral-card-head"
                            >
                              {t('referral.header.left.card_2')}
                            </div>
)}
                        >
                          <div className="cover-referral-card-body">0%</div>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>

            <Affix className={`${size}-list-referral list-referral`}>
              <div style={{ background: '#d23fd4' }}>
                <List
                  size="large"
                  className={`${size}-list-referral-navbar list-referral-navbar`}
                  dataSource={[{}]}
                  split={false}
                  itemLayout="vertical"
                  renderItem={(item) => (
                    <div className={`${size}-list-referral-menu list-referral-menu`}>
                      <List.Item key="dashboard" className="list-referral-item">
                        <a
                          ref={(ref) => myRef[0] = ref}
                          onClick={() => executeScroll(0)}
                          className="list-referral-link"
                          href="#dashboard"
                        >
                          {t('referral.menu.link_1')}
                        </a>
                      </List.Item>
                      <List.Item key="referralLink" className="list-referral-item">
                        <a
                          ref={(ref) => myRef[1] = ref}
                          onClick={() => executeScroll(1)}
                          className="list-referral-link"
                          href="#referralLink"
                        >
                          {t('referral.menu.link_2')}
                        </a>
                      </List.Item>
                      <List.Item key="friendList" className="list-referral-item">
                        <a
                          ref={(ref) => myRef[2] = ref}
                          onClick={() => executeScroll(2)}
                          className="list-referral-link"
                          href="#friendList"
                        >
                          {t('referral.menu.link_3')}
                        </a>
                      </List.Item>
                      <List.Item key="commission" className="list-referral-item">
                        <a
                          ref={(ref) => myRef[3] = ref}
                          onClick={() => executeScroll(3)}
                          className="list-referral-link"
                          href="#commission"
                        >
                          {t('referral.menu.link_4')}
                        </a>
                      </List.Item>
                      <List.Item key="share" className="list-referral-item">
                        <a
                          ref={(ref) => myRef[4] = ref}
                          onClick={() => executeScroll(4)}
                          className="list-referral-link"
                          href="#share"
                        >
                          {t('referral.menu.link_5')}
                        </a>
                      </List.Item>
                    </div>
                  )}
                />
              </div>
            </Affix>

            <div className="body-with-login">
              <div className="dashboard pt-120" id="dashboard">
                <div className={`${size}-dashboard-body dashboard-body`}>
                  <div className="d-flex align-items fz-32 fontW-700">
                    <DotChartOutlined />
                    <div className="ml-small">{t('referral.menu.link_1')}</div>
                  </div>
                  <Tabs defaultActiveKey="1" className="dashboard-body-tabs">
                    <TabPane tab={t('referral.body.link_1.tabs_1')} key="1">
                      <Descriptions title="User Info">
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_1')}
                        >
                          {t('referral.body.link_1.tabs_1')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_2')}
                        >
                          {t('referral.body.link_1.tabs_2')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_3')}
                        >
                          {t('referral.body.link_1.tabs_3')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_4')}
                        >
                          {t('referral.body.link_1.tabs_4')}
                        </Descriptions.Item>
                      </Descriptions>
                    </TabPane>
                    <TabPane tab="Tab 2" key="2">
                      <Descriptions title="User Info">
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_1')}
                        >
                          {t('referral.body.link_1.tabs_1')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_2')}
                        >
                          {t('referral.body.link_1.tabs_2')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_3')}
                        >
                          {t('referral.body.link_1.tabs_3')}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={t('referral.body.link_1.tabs_4')}
                        >
                          {t('referral.body.link_1.tabs_4')}
                        </Descriptions.Item>
                      </Descriptions>
                    </TabPane>
                    <TabPane tab="Tab 3" key="3">
                      <Descriptions title="User Info">
                        <Descriptions title="User Info">
                          <Descriptions.Item
                            label={t('referral.body.link_1.tabs_1')}
                          >
                            {t('referral.body.link_1.tabs_1')}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={t('referral.body.link_1.tabs_2')}
                          >
                            {t('referral.body.link_1.tabs_2')}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={t('referral.body.link_1.tabs_3')}
                          >
                            {t('referral.body.link_1.tabs_3')}
                          </Descriptions.Item>
                          <Descriptions.Item
                            label={t('referral.body.link_1.tabs_4')}
                          >
                            {t('referral.body.link_1.tabs_4')}
                          </Descriptions.Item>
                        </Descriptions>
                      </Descriptions>
                    </TabPane>
                  </Tabs>
                  <div className="dashboard-body-text">
                    {t('referral.body.link_1.text_1')}
                  </div>
                  <div className="dashboard-body-text">
                    {t('referral.body.link_1.text_2')}
                  </div>

                </div>
              </div>

              <div className="referralLink pt-120" id="referralLink">
                <div className={`${size}-referralLink-body referralLink-body`}>
                  <div className="d-flex align-items fz-32 fontW-700">
                    <UserAddOutlined />
                    <div className="ml-small">{t('referral.menu.link_2')}</div>
                  </div>
                  <div className="d-flex space-between align-items mt-small mb-small">
                    <div className="referralLink-body-text">
                      {t('referral.body.link_2.columns_1')}
                    </div>
                    <Button type="link" icon={<PlusOutlined />} size="large" className="referralLink-body-button">
                      {t('referral.header.left.button_1')}
                    </Button>
                  </div>
                  <Table dataSource={dataSource2} columns={columnsOfTable2} />
                </div>
              </div>

              <div className="friendList pt-120" id="friendList">
                <div className={`${size}-friendList-body friendList-body`}>
                  <div className="d-flex align-items fz-32 fontW-700">
                    <GrGroup />
                    <div className="ml-small">{t('referral.menu.link_3')}</div>
                  </div>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab={t('referral.body.all_accounts')} key="1">
                      <Table dataSource={dataSource3} columns={columnsOfTable3} />
                    </TabPane>
                    <TabPane tab=" Spot" key="2">
                      <Table dataSource={dataSource3} columns={columnsOfTable3} />
                    </TabPane>
                    <TabPane tab=" Futures" key="3">
                      <Table dataSource={dataSource3} columns={columnsOfTable3} />
                    </TabPane>
                    <TabPane tab=" Futures" key="4">
                      <Table dataSource={dataSource3} columns={columnsOfTable3} />
                    </TabPane>
                  </Tabs>
                </div>
              </div>

              <div className="commission pt-120" id="commission">
                <div className={`${size}-commission-body commission-body`}>
                  <div className="d-flex align-items fz-32 fontW-700">
                    <FaBitcoin />
                    <div className="ml-small">{t('referral.menu.link_4')}</div>
                  </div>
                  <div className="cover-content">
                    <Tabs defaultActiveKey="1">
                      <TabPane tab={t('referral.body.all_accounts')} key="1">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Spot" key="2">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Futures" key="3">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Futures" key="4">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
              </div>

              <div className="share pt-120" id="share">
                <div className={`${size}-share-body share-body`}>
                  <div className="d-flex align-items fz-32 fontW-700">
                    <UserAddOutlined />
                    <div className="ml-small">{t('referral.menu.link_5')}</div>
                  </div>
                  <div className="cover-content">
                    <Tabs defaultActiveKey="1">
                      <TabPane tab={t('referral.body.all_accounts')} key="1">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Spot" key="2">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Futures" key="3">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                      <TabPane tab=" Futures" key="4">
                        <Table dataSource={dataSource3} columns={columnsOfTable3} />
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer">
              <Footer />
            </div>
          </div>
          <Modal
            className="referral-modal"
            title={
              <div className=" fz-20 fontW-700">Tạo liên kết</div>
            }
            width={360}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Xác nhận"
            cancelText="Hủy"
          >
            <div className="text-black mb-small">
              Tỷ lệ hoa hồng cơ sở của bạn
              {' '}
              <b className="text-black">20%</b>
              {' '}
              <br />
              Đặt tỉ lệ hoàn trả hoa hồng cho bạn bè
            </div>
            <div className="d-flex space-between">
              <Card size="small" title={<div className="referral-modal-head">Bạn nhận được</div>}>
                <div className="referral-modal-body"> 20%</div>
              </Card>
              <Card size="small" title={<div className="referral-modal-head">Bạn bè nhận được</div>}>
                <div className="referral-modal-body">0%</div>
              </Card>
            </div>
            <div className="mt-medium mb-medium d-flex space-between">
              <Button onClick={() => onSetReceive(0)} type="primary">0%</Button>
              <Button onClick={() => onSetReceive(5)} type="primary">5%</Button>
              <Button onClick={() => onSetReceive(10)} type="primary">10%</Button>
              <Button onClick={() => onSetReceive(15)} type="primary">15%</Button>
              <Button onClick={() => onSetReceive(20)} type="primary">20%</Button>
            </div>
            <Paragraph editable={{ onChange: setEditableStr }}>{editableStr}</Paragraph>
            <Checkbox onChange={onSetDefaultCode}>Đặt mã giới thiệu mặc định</Checkbox>
          </Modal>
        </>
      )}
    </Translation>
  );
}

export default ReferralWithLoginComponent;
